

export class Integration {
    constructor(
        public id: number = null,
        public name: string = '',
        public timeSequenceType: string = '',
        public uses: Array<any> = [],
        public enableStatus = false,
        public allowResidentsToBook = false,
        public requiresManagerApproval = false,
        public allowEventTypeBooking = false,
        public legalAgreement: string = '',
        public legalAgreementStatus = false,
        public disclaimer: string = '',
        public disclaimerStatus = false,
        public multipleBooking = false,
        public multipleBookingMaxCount: number = null,
        public amenityImage: string = '',
        public rule: any = null,
        public bookings: Array<any> = null,
        public fees: Array<any> = null,
        public disabledDates: Array<any> = null,
        public buildingAmenity: any = [],
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true,
        public internalId: string = '',
        public template: string = '',
        public saveAsTemplate = false,
        public templateName: string = '',
        public bookingMinDay: number = null,
        public bookingMaxDay: number = null,
        public bookingMinHour: number = null,
        public bookingMaxHour: number = null,
        public limitActivityRangeValue: string = '',
        public minIntervalBetweenBooking: string = '',
        public technicalBreak: string = '',
        public limitActivityCountBookingOrDays: string = '',
        public limitActivityCountBookingOrHours: string = '',
        public limitActivityCountBooking: string = '',
        public maxTimeForAdvancedBooking: string = '',
        public minTimeForAdvancedBooking: string = '',
        public confirmationMessage: string = '',
        public staffNotificationSettings: any = null,
        public residentsNotificationSettings: any = null,
        public legalAgreementHideFromStaffInterface: boolean = false,
        public disclaimerHideFromStaffInterface: boolean = false,
        public paymentAcceptCreditCards: boolean = false,
        public paymentAcceptCash: boolean = false,
        public paymentAcceptCheques: boolean = false,
        public paymentAcceptCustomType: boolean = false,
        public paymentCustomTypeName: string = '',
        public defaultPaymentMethod: string = '',
        public amenityColor: string = '',
        public managementOverride: boolean = false,
        public formFields = {
            defaultPaymentMethod: {editMode: false}
        },
        public reminders: Array<any> = [],
        public createdBy: string = '',
        public createdAt: string = ''
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Integration.ts